class ArticleCardVideo extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      videoContainer: '[js-video-container]'
    }
  }

  connectedCallback() {
    this.modal = document.querySelector('#VideoModal')
    this.videoContainer = this.modal.querySelector(this._selectors.videoContainer);

    this._setupEventListeners();
  }

  _setupEventListeners() {
    this.addEventListener('click', this._configModal)
    this.modal.addEventListener('close', this._removeVideo)
  }

  _configModal = (e) => {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
    const trigger = e.currentTarget;
    const ar = trigger.getAttribute('data-ar')
    const youtubeId = trigger.getAttribute('data-youtube')
    let videoMarkup = '';

    if(youtubeId != '') {
      videoMarkup = `<iframe class="absolute top-0 left-0 w-full h-full" src="https://www.youtube.com/embed/${youtubeId}?&rel=0&showinfo=0&controls=1&loop=0&mute=0?enablejsapi=1" frameborder="0" js-video></iframe>`
    }else{
      videoMarkup = trigger.getAttribute('data-video')
    }

    this._insertVideo(videoMarkup)

    this.modal.style.setProperty('--aspect-ratio', ar);
    this.modal.setAttribute('data-layout', ar);
    this.modal.open();
  }

  _insertVideo = (video) => {
    this.videoContainer.insertAdjacentHTML('beforeend', video)
  }

  _removeVideo = () => {
    this.videoContainer.innerHTML = '';
  }
}

if (!customElements.get('article-card-video')) customElements.define('article-card-video', ArticleCardVideo)